/**
 * Logos vector inlineados para Google / Microsoft. Evita dependencia de svgr o
 * @mui/icons-material para 2 íconos. Tomados de los brand guidelines oficiales.
 */

export function GoogleLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" width={18} height={18} aria-hidden {...props}>
      <path
        fill="#4285F4"
        d="M22.501 12.233c0-.815-.073-1.6-.21-2.353H12v4.448h5.892a5.04 5.04 0 0 1-2.183 3.31v2.745h3.532c2.072-1.91 3.26-4.722 3.26-8.15z"
      />
      <path
        fill="#34A853"
        d="M12 23c2.955 0 5.435-.98 7.245-2.655l-3.532-2.745c-.98.66-2.235 1.045-3.713 1.045-2.85 0-5.265-1.925-6.13-4.515H2.243v2.835A10.997 10.997 0 0 0 12 23z"
      />
      <path
        fill="#FBBC05"
        d="M5.87 14.13a6.6 6.6 0 0 1 0-4.26V7.035H2.243a11 11 0 0 0 0 9.93l3.627-2.835z"
      />
      <path
        fill="#EA4335"
        d="M12 5.625c1.61 0 3.05.555 4.187 1.64l3.135-3.135C17.43 2.085 14.955 1 12 1 7.83 1 4.23 3.39 2.243 7.035L5.87 9.87C6.735 7.28 9.15 5.625 12 5.625z"
      />
    </svg>
  );
}

export function CheckIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.8" {...props}>
      <path d="M3 8l3.5 3.5L13 5" />
    </svg>
  );
}

export function InfoCircleIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" {...props}>
      <circle cx="8" cy="8" r="6" />
      <path d="M8 5v3M8 11h.01" />
    </svg>
  );
}

export function ShieldIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" {...props}>
      <path d="M8 1.5l5.5 2v4c0 3.5-2.4 6.5-5.5 7-3.1-.5-5.5-3.5-5.5-7v-4l5.5-2z" />
    </svg>
  );
}

export function MailIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" {...props}>
      <rect x="1.5" y="3" width="13" height="10" rx="1.5" />
      <path d="M2 4l6 4 6-4" />
    </svg>
  );
}

export function MicrosoftLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 21 21" width={18} height={18} aria-hidden {...props}>
      <rect x="1" y="1" width="9" height="9" fill="#F25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
      <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
      <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
    </svg>
  );
}
